import _get from 'lodash/get'

const EMPTY = '—'

// Espelha api-cc-profilers/src/lib/defaultVars.js: $variável → valor no payload do exec
const VARIABLES = [
  { name: '$ura', label: 'URA', value: (p) => p.ura },
  { name: '$fila', label: 'Fila', value: (p) => p.queue },
  { name: '$ramal', label: 'Ramal', value: (p) => p.extension },
  { name: '$matricula', label: 'Matrícula', value: (p) => p.agent },
  { name: '$telefone', label: 'Telefone', value: (p) => p.contact },
  { name: '$mailing', label: 'Mailing', value: (p) => p.mailing },
  { name: '$flow', label: 'Fluxo', value: (p) => p.flow ?? p.flowVariables },
  { name: '$agente', label: 'Agente', value: (p) => p.agentName },
  { name: '$perfilador', label: 'Perfilador', value: (p) => p.profiler },
  { name: '$data', label: 'Data', value: (p) => p.created },
  { name: '$atendimentoID', label: 'Atendimento', value: (p) => p.callId ?? p.chatId },
  { name: '$canal', label: 'Canal', value: (p) => p.channel },
  { name: '$direcao', label: 'Direção', value: (p) => p.direction },
  { name: '$contatoId', label: 'ID do contato', value: (p) => p.contactId },
  { name: '$contatoNome', label: 'Nome do contato', value: (p) => p.contactName }
]

const format = (value) => {
  if (value === null || value === undefined || value === '') return EMPTY
  return typeof value === 'object' ? JSON.stringify(value) : String(value)
}

const resolve = (name, payload) => {
  const [root, ...path] = name.split('.')
  const variable = VARIABLES.find((item) => item.name.toLowerCase() === root.toLowerCase())
  if (!variable) return null
  const rootValue = variable.value(payload || {})
  return {
    label: path.length ? name : variable.label,
    value: format(path.length ? _get(rootValue, path.join('.')) : rootValue)
  }
}

// Resumo do que o hook envia: só as $variáveis que ele usa, com o valor deste atendimento
export default (variables, payload) => (Array.isArray(variables) ? variables : [])
  .map((name) => resolve(String(name), payload))
  .filter(Boolean)
